import { type FitViewOptions } from '@xyflow/react'

export const TREE_FIT_VIEW_OPTIONS: FitViewOptions = {
  duration: 300,
  padding: 0.2,
  maxZoom: 1,
}
